import { rejectFailedRequestOrEmptyData } from '../../lib/request/rejectFailedRequest/rejectFailedRequest';
import { AxiosProxy } from '../axiosProxy/axiosProxy';
import {
  DeleteAiModelSearchHistoryResponseData,
  GetAiModelDetailResponseData,
  GetAiModelQuickSearchRequestQueryParams,
  GetAiModelQuickSearchResponseData,
  GetAiModelSearchHistoryResponseData,
  GetAiModelTrendingResponseData,
  PostAiModelAnalysisRequestBody,
  PostAiModelAnalysisResponseData,
} from '@manifest-cyber/types/interface/contracts/model-analysis';

export const quickSearch = async ({
  query,
}: GetAiModelQuickSearchRequestQueryParams): Promise<GetAiModelQuickSearchResponseData> => {
  const url = `model-analysis/quicksearch?query=${encodeURIComponent(query)}`;
  const response = await AxiosProxy.get({ url });
  const validatedResponse =
    await rejectFailedRequestOrEmptyData<GetAiModelQuickSearchResponseData>(response);
  return validatedResponse.data;
};

export const getTrendingModels = async (): Promise<GetAiModelTrendingResponseData> => {
  const url = `model-analysis/trending`;
  const response = await AxiosProxy.get({ url });
  const validatedResponse =
    await rejectFailedRequestOrEmptyData<GetAiModelTrendingResponseData>(response);
  return validatedResponse.data;
};

export const getRecentModelSearches =
  async (): Promise<GetAiModelSearchHistoryResponseData> => {
    const url = `model-analysis/search/history`;
    const response = await AxiosProxy.get({ url });
    const validatedResponse =
      await rejectFailedRequestOrEmptyData<GetAiModelSearchHistoryResponseData>(response);
    return validatedResponse.data;
  };

export const recordModelSearch = async ({
  kind,
  repo,
  owner,
  revision,
  includeArxivData,
}: PostAiModelAnalysisRequestBody & {
  includeArxivData: boolean;
}): Promise<PostAiModelAnalysisResponseData> => {
  const url = `model-analysis`;
  const response = await AxiosProxy.post({
    url,
    body: {
      kind,
      repo,
      owner,
      revision,
      includeArxivData,
    },
  });
  const validatedResponse =
    await rejectFailedRequestOrEmptyData<PostAiModelAnalysisResponseData>(response);
  return validatedResponse.data;
};

export const clearRecentModelSearches =
  async (): Promise<DeleteAiModelSearchHistoryResponseData> => {
    const url = `model-analysis/search/history`;
    const response = await AxiosProxy.delete({ url });
    const validatedResponse =
      await rejectFailedRequestOrEmptyData<DeleteAiModelSearchHistoryResponseData>(
        response,
      );
    return validatedResponse.data;
  };

export const fetchModel = async (
  modelId: string,
): Promise<GetAiModelDetailResponseData> => {
  const safeModelId = encodeURIComponent(modelId);
  const url = `model-analysis/${safeModelId}`;
  const response = await AxiosProxy.get({ url });
  const validatedResponse =
    await rejectFailedRequestOrEmptyData<GetAiModelDetailResponseData>(response);
  return {
    ...validatedResponse.data,
    dateCreated: new Date(validatedResponse.data.dateCreated!),
  };
};
